import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} UpdatePassingPercentageResponse
 * @property {boolean} success
 * @property {string} message
 * @property {{ passing_percentage: number }} data
 */

/**
 * Hook to update passing percentage
 */
export const useUpdatePassingPercentage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(
    /** @type {UpdatePassingPercentageResponse | null} */ (null),
  );

  const { axiosInstance } = useAxios();

  /**
   * Update Passing Percentage
   * @param {object} params
   * @param {number} params.percentage
   * @param {()=> void} params.onSuccess
   * @param {(message:string)=> void} params.onError
   */
  const updatePassingPercentage = async ({
    percentage,
    onSuccess,
    onError,
  }) => {
    try {
      setLoading(true);
      setError("");
      setResult(null);

      const url = `${TENANT_DOMAIN}/school/admin/settings/passing-percentage`;

      const response = await axiosInstance.patch(url, {
        passing_percentage: percentage,
      });
      onSuccess();

      setResult(response.data || null);
    } catch (err) {
      setResult(null);
      let firstErrorMessage = ERROR_MESSAGES.INTERNAL_SERVER;
      if (err?.response?.data?.errors) {
        firstErrorMessage = Object.values(err?.response?.data?.errors)[0][0];
      }

      if (err?.response?.status === 500) {
        firstErrorMessage = ERROR_MESSAGES.INTERNAL_SERVER;
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        if (!firstErrorMessage)
          firstErrorMessage =
            err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN;
        setError(
          firstErrorMessage ||
            err?.response?.data?.message ||
            ERROR_MESSAGES.UNKNOWN,
        );
      }
      console.log("FIRST error message" + firstErrorMessage);
      onError(firstErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    updatePassingPercentage,
    loading,
    error,
    result,
  };
};
